// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font {
  display: flex;
  justify-content: center;
  border-radius: 8px;
  height: auto;
  box-shadow: 5px 5px 8px #c4c5ea;
  background-color: rgb(211, 253, 253);
  padding: 15px;
  width: 70%;
}

td {
  display: column;
  border: 3px solid rgb(10, 9, 9);
  text-align: center;
  color: #000;
  font-size: 0.8rem;
}

table {
  border-collapse: collapse;
}

.header,
th {
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  border: 4px solid rgb(10, 9, 9);
  color: #000;
}

.prono-road,
.prono-home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
  align-items: center;
}

.versus {
  margin-right: 100px;
  margin-left: 100px;
}

.prono-opposition {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.statsWiner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.band-title {
  margin-top: 10px;
  align-items: center;
  color: rgb(211, 253, 253);
}

.winner-team,
.winner-odd {
  font-size: 25px;
  font-style: italic;
  font-weight: bold;
  margin-top: 10px;
}

.prono-score {
  font-size: 25px;
  font-weight: bold;
  margin-top: 15px;
}

.off-total {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.prono-title {
  margin-top: 20px;
  color: rgb(211, 253, 253);
}

.overtime {
  margin-top: 5px;
}

td:nth-child(1),
td:nth-child(5) {
  width: 50px;
}

td:nth-child(2),
td:nth-child(4) {
  width: 170px;
}

td:nth-child(3) {
  width: 90px;
}

td:nth-child(6) {
  width: 90px;
}

@media only screen and (max-width: 600px) {
  /* For mobile phones: */
  tr {
    font-size: 8px !important;
  }
  th,
  .header {
    font-size: 10px !important;
  }
  td {
    font-size: 8px;
  }
  td:nth-child(1),
  td:nth-child(5) {
    width: 30px;
  }
  td:nth-child(2),
  td:nth-child(4) {
    width: 80px;
  }
  td:nth-child(3) {
    width: 70px;
  }
  td:nth-child(6) {
    width: 60px;
  }
  .prono-road,
  .prono-home {
    padding-right: 150px;
    font-size: 10px;
    font-weight: bold;
  }
  .prono-title {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/stats-analyser/stats-analyser.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,oCAAA;EACA,aAAA;EACA,UAAA;AACF;;AAGA;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EAEA,+BAAA;EACA,WAAA;AADF;;AAKA;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;AAFF;;AAMA;;EAEE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,yBAAA;AAJF;;AAQA;EACE,eAAA;AALF;;AAQA;;EAEE,WAAA;AALF;;AAQA;;EAEE,YAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EAEE,uBAAA;EACA;IACE,yBAAA;EANF;EASA;;IAEE,0BAAA;EAPF;EAUA;IACE,cAAA;EARF;EAWA;;IAEE,WAAA;EATF;EAYA;;IAEE,WAAA;EAVF;EAaA;IACE,WAAA;EAXF;EAcA;IACE,WAAA;EAZF;EAeA;;IAEE,oBAAA;IACA,eAAA;IACA,iBAAA;EAbF;EAgBA;IACE,eAAA;EAdF;AACF","sourcesContent":[".font {\r\n  display: flex;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  height: auto;\r\n  box-shadow: 5px 5px 8px #c4c5ea;\r\n  background-color: rgb(211, 253, 253);\r\n  padding: 15px;\r\n  width: 70%;\r\n\r\n}\r\n\r\ntd {\r\n  display: column;\r\n  border: 3px solid rgb(10, 9, 9);\r\n  text-align: center;\r\n  color: #000;\r\n  font-size: 0.8rem;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n}\r\n\r\n.header,\r\nth {\r\n  font-weight: bold;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  // width: fit-content;\r\n  border: 4px solid rgb(10, 9, 9);\r\n  color: #000;\r\n\r\n}\r\n\r\n.prono-road,\r\n.prono-home {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n  align-items: center;\r\n}\r\n\r\n.versus {\r\n  margin-right: 100px;\r\n  margin-left: 100px;\r\n}\r\n\r\n.prono-opposition {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.statsWiner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.band-title {\r\n  margin-top: 10px;\r\n  align-items: center;\r\n  color: rgb(211, 253, 253);\r\n}\r\n\r\n\r\n.winner-team,\r\n.winner-odd {\r\n  font-size: 25px;\r\n  font-style: italic;\r\n  font-weight: bold;\r\n  margin-top: 10px;\r\n\r\n}\r\n\r\n.prono-score {\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n  margin-top: 15px;\r\n}\r\n\r\n.off-total {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.prono-title {\r\n  margin-top: 20px;\r\n  color: rgb(211, 253, 253);\r\n\r\n}\r\n\r\n.overtime {\r\n  margin-top: 5px;\r\n}\r\n\r\ntd:nth-child(1),\r\ntd:nth-child(5) {\r\n  width: 50px;\r\n}\r\n\r\ntd:nth-child(2),\r\ntd:nth-child(4) {\r\n  width: 170px;\r\n}\r\n\r\ntd:nth-child(3) {\r\n  width: 90px;\r\n}\r\n\r\ntd:nth-child(6) {\r\n  width: 90px;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n\r\n  /* For mobile phones: */\r\n  tr {\r\n    font-size: 8px !important;\r\n  }\r\n\r\n  th,\r\n  .header {\r\n    font-size: 10px !important;\r\n  }\r\n\r\n  td {\r\n    font-size: 8px;\r\n  }\r\n\r\n  td:nth-child(1),\r\n  td:nth-child(5) {\r\n    width: 30px;\r\n  }\r\n\r\n  td:nth-child(2),\r\n  td:nth-child(4) {\r\n    width: 80px;\r\n  }\r\n\r\n  td:nth-child(3) {\r\n    width: 70px;\r\n  }\r\n\r\n  td:nth-child(6) {\r\n    width: 60px;\r\n  }\r\n\r\n  .prono-road,\r\n  .prono-home {\r\n    padding-right: 150px;\r\n    font-size: 10px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .prono-title {\r\n    font-size: 15px;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
